import { createContext, useContext, useEffect, useRef, useState } from 'react';
import api from '../config/axiosConfig';

const NotificationsContext = createContext();

export const useNotifications = () => useContext(NotificationsContext);

export const NotificationsProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const timeoutsRef = useRef([]);

  const fetchNotifications = async () => {
    try {
      const response = await api.get('/users/me/notifications');
      const newNotifications = response.data || [];

      setNotifications((prev) => {
        const prevMap = new Map(prev.map(n => [n.id, n]));
        const updated = newNotifications.map(n => {
          const existing = prevMap.get(n.id);
          return existing ? { ...existing, ...n } : n;
        });
        return updated;
      });
    } catch (error) {
      console.error('Erreur lors de la récupération des notifications:', error);
      //toast.error('Erreur lors de la récupération des notifications');
    }
  };

  const addNotification = (notification) => {
    if (!notification.message || !notification.type || !notification.id) {
      console.warn('Tentative d\'ajout d\'une notification invalide:', notification);
      return;
    }

    setNotifications((prev) => {
      const exists = prev.some((n) => n.id === notification.id);
      if (exists) {
        // Mise à jour si déjà présente (ex: read a changé)
        return prev.map(n => n.id === notification.id ? { ...n, ...notification } : n);
      }
      console.log('Ajout d\'une nouvelle notification:', notification);
      return [...prev, notification];
    });

    // Auto-remove après 5s sauf pour les certificats
    if (notification.type !== 'certificate') {
      const timeoutId = setTimeout(() => {
        removeNotification(notification.id);
      }, 5000);
      timeoutsRef.current.push({ id: notification.id, timeoutId });
    }
  };

  const removeNotification = async (id) => {
    try {
      // Marque comme lue côté API
      await api.patch(`/users/me/notifications/${id}/read`);

      // Met à jour localement
      setNotifications((prev) =>
        prev.map((n) => (n.id === id ? { ...n, read: true } : n))
      );

      // Annule le timeout
      timeoutsRef.current = timeoutsRef.current.filter((timeout) => {
        if (timeout.id === id) {
          clearTimeout(timeout.timeoutId);
          return false;
        }
        return true;
      });
    } catch (error) {
      console.error('Erreur lors du marquage de la notification:', error);
      //toast.error('Erreur lors du marquage de la notification');
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 60000); // Changé à 60 secondes
    return () => clearInterval(interval);
  }, []);

  return (
    <NotificationsContext.Provider value={{ notifications, addNotification, removeNotification, fetchNotifications }}>
      {children}
    </NotificationsContext.Provider>
  );
};